import { Component, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { BullhornFieldType } from '../../data-rules-model';
import { AutocompleteComponent } from '../../lib/autocomplete/autocomplete.component';
import { ProviderFactory } from '../../lib/provider-factory';
import { IActionFieldMeta, MetaDataService } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-change',
  templateUrl: './change.component.html',
  imports: [
    AutocompleteComponent
  ],
  styleUrls: ['../action.component.scss']
})
export class ChangeComponent extends BaseActionComponent {
  toManyPlaceholderText: string;

  @ViewChild('fieldValue')
  set fieldValue(v: AutocompleteComponent) {
    setTimeout(() => this.setValuePickerComponent(v), 0);
  }

  private valuePickerComponent: AutocompleteComponent;

  public constructor(protected metaDataService: MetaDataService, private providerFactory: ProviderFactory) {
    super(metaDataService);
  }

  protected initialiseControls(): void {
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.valueControl.setValue(null);
      this.valuePickerComponent.clearOption();
      return;
    }

    this.valueControl.setValidators(selectedField.metaType === BullhornFieldType.STRING ||
    selectedField.metaType === BullhornFieldType.BOOLEAN ? null : Validators.required);

    this.destinationTypeControl.setValue(selectedField.metaType);

    this.valueControl.setValue(null);

    this.lookUpEntityChange(selectedField);
  }

  private setValuePickerComponent(acComponent: AutocompleteComponent): void {
    this.valuePickerComponent = acComponent;

    // fieldName will be null if this is a new action
    const fieldName = this.destinationControl.value;
    if (this.valuePickerComponent && fieldName) {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const meta = filteredMeta.find(fm => fm.fieldName === fieldName);
          this.toManyPlaceholderText = 'Loading...';
          this.valueControl.disable();

          this.providerFactory.getOptionsProvider(this.valueControl.value, meta).subscribe(provider => {
            this.valuePickerComponent.setOptionsProvider(provider, this.valueControl.value);
            this.toManyPlaceholderText = undefined;
            this.valueControl.enable();
          });
        });
    }
  }

  private lookUpEntityChange(fieldMeta: IActionFieldMeta): void {
    if (!this.valuePickerComponent)
      return;

    this.providerFactory.getOptionsProvider([], fieldMeta).subscribe(optionsProvider => {
      this.valuePickerComponent.setOptionsProvider(optionsProvider);
    });
  }
}
